<template>
<div class="title-text">
    <h5
        v-if="hasTitle === true"
        class="section-title"
    >
        {{ title }}
    </h5>
    <p
        v-for="(p,index) in textWithBreaks"
        :key="index"
    >
        <span
            v-for="(l,j) in p"
            :key="j"
        >
            <br v-if="j>0">
            {{ l }}
        </span>
    </p>
</div>
</template>
<script>
export default {
    props: {
        // title
        title: {
            type: String,
            default: null
        },
        // text/paragraph/description
        text: {
            type: String,
            required: true
        }
    },

    computed: {
        /**
         * Creates 2d array
         * Strips 2+ newlines
         * @return {Array}
         */
        textWithBreaks() {
            const textArr = this.text.split(/\r?\n\s*\r?\n/g);
            const text2d = [];

            for (var i = 0; i < textArr.length; i++) {
                text2d.push(textArr[i].split(/\r?\n/));
            }

            return text2d;
        },
        /**
         * Determines if there is a title
         * @return {Boolean}
         */
        hasTitle() {
            if (this.title === null || this.title.length === 0) {
                return false;
            }
            return true;
        }
    }
};
</script>
